var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "useraddress" },
    [
      _c("headbox", {
        attrs: {
          title: _vm.titleiInt,
          bgColor: "#fff",
          isborder: "true",
          isnohref: "true"
        }
      }),
      _c("div", { staticClass: "box" }, [
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticClass: "titleinfo" }, [_vm._v("联系人")]),
          _c(
            "div",
            [
              _c("el-input", {
                attrs: { placeholder: "请输入" },
                model: {
                  value: _vm.postForm.name,
                  callback: function($$v) {
                    _vm.$set(_vm.postForm, "name", $$v)
                  },
                  expression: "postForm.name"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "flex" }, [
          _c("div", { staticClass: "titleinfo" }, [_vm._v("联系电话")]),
          _c(
            "div",
            [
              _c("el-input", {
                attrs: { placeholder: "请输入", maxlength: "11" },
                model: {
                  value: _vm.postForm.phone,
                  callback: function($$v) {
                    _vm.$set(_vm.postForm, "phone", $$v)
                  },
                  expression: "postForm.phone"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "flex cityselect" }, [
          _c("div", { staticClass: "titleinfo" }, [_vm._v("所在城市")]),
          _c(
            "div",
            {
              class: _vm.issslect ? "citybox drepcolor" : " citybox",
              staticStyle: { flex: "2" },
              on: { click: _vm.showPopup }
            },
            [_vm._v(" " + _vm._s(_vm.initCity) + " ")]
          ),
          _vm._m(0)
        ]),
        _c("div", { staticClass: "flex nonePadd " }, [
          _c("div", { staticClass: "titleinfo" }, [_vm._v("详细地址")]),
          _c(
            "div",
            { staticStyle: { flex: "1" } },
            [
              _c("el-input", {
                staticClass: "textareabox",
                attrs: {
                  placeholder: "例如：**街**号",
                  type: "textarea",
                  rows: 2
                },
                model: {
                  value: _vm.postForm.textareabox,
                  callback: function($$v) {
                    _vm.$set(_vm.postForm, "textareabox", $$v)
                  },
                  expression: "postForm.textareabox"
                }
              })
            ],
            1
          )
        ]),
        _vm.defaultAddress
          ? _c("div", { staticClass: "flex  lastbox " }, [
              _c(
                "div",
                [
                  _c("el-checkbox", {
                    model: {
                      value: _vm.checked,
                      callback: function($$v) {
                        _vm.checked = $$v
                      },
                      expression: "checked"
                    }
                  })
                ],
                1
              ),
              _c("div", { staticClass: "titleinfo onlyaddress" }, [
                _vm._v("设置为默认地址")
              ])
            ])
          : _vm._e(),
        _c(
          "div",
          {
            staticClass: "save",
            style: { background: _vm.save ? "#ff2d2e" : "#f7cdcd" },
            on: { click: _vm.savedata }
          },
          [_vm._v(" " + _vm._s(_vm.saveName) + " ")]
        )
      ]),
      _c(
        "div",
        [
          _c(
            "van-popup",
            {
              attrs: { position: "bottom" },
              model: {
                value: _vm.show,
                callback: function($$v) {
                  _vm.show = $$v
                },
                expression: "show"
              }
            },
            [
              _c("van-area", {
                attrs: {
                  "area-list": _vm.areaList,
                  value: _vm.addrCode,
                  "cancel-button-text": " "
                },
                on: { confirm: _vm.confirmF }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("i", { staticClass: "el-icon-arrow-right" })])
  }
]
render._withStripped = true

export { render, staticRenderFns }